import React, { useEffect, useState } from "react";
import MainBg from "../../components/Mainbg";
import { Swiper, SwiperSlide, Navigation } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";

import secureLocalStorage from "react-secure-storage";
import axios from "axios";
import { GET_TRACK_HEALTH } from "../../config/ApisCollection";
import BaseImage from "../../assets/images/dasboard/base.webp";
import {
  monthlist,
  getDatesWithDayNames,
  WeekInMonth,
} from "../../function/functions";
import { Link } from "react-router-dom";
import tracknotfound from "../../assets/images/track-not-found.png";
import {
  DaySlideSection,
  DayWeekTabSection,
  NotFound,
  TrackDateFilterSection,
  WeekSlideSection,
} from "../../components/TrackCommonSection";

const HealthTrack = ({ weekStart = "Sunday" }) => {
  const accessToken = secureLocalStorage.getItem("accessToken");
  // Update current date, month, and year on component mount
  const now = new Date();
  const year = now.getFullYear();
  const month = (now.getMonth() + 1).toString().padStart(2, "0"); // Months are 0-indexed and should be 2 digits
  const day = String(now.getDate()).padStart(2, "0"); // Ensure day is 2 digits
  const current_date = `${year}-${month}-${day}`; // Ensure day is 2 digits
  // const dayOfWeek = now.getDay();
  const dayOfWeek = day;
  let hasValidData = false;
  let weekhasValidData = false;
  // const current_month = month;
  const current_dayinweek = 3;
  // Get the current week of the month
  const firstDayOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
  const firstWeekday = firstDayOfMonth.getDay(); // Day of the week for the 1st of the month
  const currentWeekfind = Math.ceil((now.getDate() + firstWeekday) / 7); // Week number in the month

  // console.log(currentWeekfind);
  const [dataTab, setDataTab] = useState("Daily");
  const [bardata, setBarData] = useState([]);
  const [activeDayTab, setActiveDayTab] = useState(current_date || null);
  const [activeWeekTab, setActiveWeekTab] = useState(currentWeekfind - 1);
  const [currentMonth, setCurrentMonth] = useState(month || null);
  const [currentYear, setCurrentYear] = useState(year || null);
  const [reportData, setReportData] = useState(null);

  const weeklist = ["Week 1", "Week 2", "Week 3", "Week 4", "Week 5"];
  // Function to get the current week with dates and day names

  const handleChange = (event) => {
    setCurrentMonth(event.target.value);
  };

  const GetTrackReport = async () => {
    const getParams = {
      month: currentMonth,
      year: currentYear,
    };

    const getHeaders = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    };

    try {
      const response = await axios.post(
        GET_TRACK_HEALTH,
        getParams,
        getHeaders
      );

      setReportData(response.data);
    } catch (error) {
      // console.log(error);
    }
  };

  // const currentWeek = getCurrentWeek(weekStart);
  const currentWeek = getDatesWithDayNames(year, currentMonth - 1);

  // console.log(dates);

  useEffect(() => {
    GetTrackReport();
  }, [activeDayTab, currentMonth, activeWeekTab]);

  return (
    <MainBg>
      <div className="container lg:w-1/4 md:w-1/3 w-full m-auto">
        <TrackDateFilterSection
          currentMonth={currentMonth}
          month={month}
          year={year}
          monthlist={monthlist}
          setCurrentYear={setCurrentYear}
          currentYear={currentYear}
          handleChange={handleChange}
        />

        <DayWeekTabSection dataTab={dataTab} setDataTab={setDataTab} />
      </div>
      {dataTab === "Daily" ? (
        <>
          {/* Daily based data report  */}
          {/* Date and day tabs  */}
          <DaySlideSection
            activeDayTab={activeDayTab}
            currentWeek={currentWeek}
            dayOfWeek={dayOfWeek}
            setActiveDayTab={setActiveDayTab}
          />

          <>
            {/* Workout list set left  */}
            <div className="container mx-auto p-4 py-2">
              <div className="grid grid-cols-1 lg:grid-cols-1 gap-4">
                {/* Table section  */}

                <div>
                  <div className="py-5">
                    <h1 className="text-xl text-black font-bold">
                      Your Activities
                    </h1>
                    <p className="text-gray text-xs">{activeDayTab}</p>
                  </div>

                  <div className="">
                    {reportData?.healthfit &&
                      reportData?.healthfit?.length > 0 &&
                      JSON.parse(reportData?.healthfit)?.daily?.map(
                        (day_row_data, index) => {
                          let day_row = null;

                          if (activeDayTab == day_row_data?.date) {
                            day_row = day_row_data;
                          }

                          if (day_row) {
                            hasValidData = true; // Mark that we found a valid day_row
                            return (
                              <div
                                className="grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-5 px-0"
                                key={index}
                              >
                                <Link
                                  to={"/track/health/details"}
                                  state={{ option: "pulse", data: null }}
                                >
                                  <div
                                    className="acitivbox w-full"
                                    style={{ background: "#fde4e3" }}
                                  >
                                    <div className="acitivlerate mb-0">
                                      <div
                                        className="acitivboxtex"
                                        style={{ color: "#E91717" }}
                                      >
                                        {day_row?.heart_rate || 0}
                                      </div>
                                      <div
                                        className="acitivboxuptexbp"
                                        style={{ color: "#E91717" }}
                                      >
                                        BPM
                                      </div>
                                    </div>
                                    <div
                                      className="acitivbox1"
                                      style={{ background: "#f9bcbb" }}
                                    >
                                      <div className="acitivboxicon -md:mt-20 -mt-10">
                                        <img
                                          loading="lazy"
                                          src="../images/deshboard/heart-beat.png"
                                          alt="heartbeat"
                                          style={{ width: "108px" }}
                                        />
                                      </div>
                                      <div
                                        className="acitivboxuptex acitivlerate"
                                        style={{
                                          color: "#E91717",
                                          marginTop: "-15%",
                                        }}
                                      >
                                        HR
                                      </div>
                                    </div>
                                  </div>
                                </Link>

                                <Link
                                  to={"/track/health/details"}
                                  state={{ option: "weight", data: null }}
                                >
                                  <div className="acitivbox w-full">
                                    <div className="acitivlerate mb-0">
                                      <div className="acitivboxtex">
                                        {reportData?.weight?.currentWeight
                                          ?.weight || 0}
                                      </div>
                                      <div className="acitivboxuptexbp">
                                        {" "}
                                        {reportData?.weight?.currentWeight
                                          ?.weightUnit || "Kg"}
                                      </div>
                                    </div>
                                    <div className="acitivbox1">
                                      <div className="acitivboxicon -md:mt-20 -mt-10">
                                        <img
                                          loading="lazy"
                                          src="../images/deshboard/weight2.png"
                                          alt="weight"
                                          style={{ width: "108px" }}
                                        />
                                      </div>
                                      <div
                                        className="acitivboxuptex acitivlerate"
                                        style={{ marginTop: "-15%" }}
                                      >
                                        Weight
                                      </div>
                                    </div>
                                  </div>
                                </Link>

                                <Link
                                  to={"/track/health/details"}
                                  state={{ option: "walk", data: null }}
                                >
                                  <div
                                    className="acitivbox w-full"
                                    style={{ background: "#e8eff7" }}
                                  >
                                    <div className="acitivlerate mb-0">
                                      <div
                                        className="acitivboxtex"
                                        style={{ color: "#197bd2" }}
                                      >
                                        {day_row?.steps || 0}
                                      </div>
                                      <div
                                        className="acitivboxuptexbp"
                                        style={{ color: "#197bd2" }}
                                      >
                                        Steps
                                      </div>
                                    </div>

                                    <div
                                      className="acitivbox1"
                                      style={{ background: "#bfd8f0" }}
                                    >
                                      <div className="acitivboxicon -md:mt-20 -mt-10">
                                        <img
                                          loading="lazy"
                                          src="../images/deshboard/arrow1.png"
                                          alt="arrow"
                                          style={{ width: "108px" }}
                                        />
                                      </div>
                                      <div
                                        className="acitivboxuptex acitivlerate"
                                        style={{
                                          color: "#197bd2",
                                          marginTop: "-15%",
                                        }}
                                      >
                                        Walk
                                      </div>
                                    </div>
                                  </div>
                                </Link>
                              </div>
                            );
                          }
                        }
                      )}
                    {!hasValidData && (
                      // Run else part when no valid day_row is found
                      <NotFound />
                    )}
                  </div>
                </div>
                {/* Line graph right section */}
              </div>
            </div>
          </>
        </>
      ) : (
        <>
          {/* Weekly active tab  */}
          <div className="w-full m-auto relative">
            <WeekSlideSection
              weeklist={weeklist}
              activeWeekTab={activeWeekTab}
              setActiveWeekTab={setActiveWeekTab}
              currentWeekfind={currentWeekfind}
            />

            <div className="container mx-auto p-4 py-2">
              <div className="grid grid-cols-1 lg:grid-cols-1 gap-4">
                {/* Table section  */}

                <div>
                  <div className="py-5">
                    <h1 className="text-xl text-black font-bold">
                      Your Activities
                    </h1>
                    <p className="text-gray text-xs">{activeDayTab}</p>
                  </div>

                  <div className="">
                    {reportData?.healthfit &&
                      reportData?.healthfit?.length > 0 &&
                      JSON.parse(reportData?.healthfit)?.weekly?.map(
                        (week_row, index) => {
                          const week_object_entries = Object.entries(week_row);

                          if (
                            "week" + activeWeekTab ==
                            week_object_entries[0][0]
                          ) {
                            weekhasValidData = true;

                            return (
                              <div
                                className="grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-5 px-0"
                                key={index}
                              >
                                <Link
                                  to={"/track/health/details"}
                                  state={{ option: "pulse", data: null }}
                                >
                                  <div
                                    className="acitivbox w-full"
                                    style={{ background: "#fde4e3" }}
                                  >
                                    <div className="acitivlerate mb-0">
                                      <div
                                        className="acitivboxtex"
                                        style={{ color: "#E91717" }}
                                      >
                                        {week_row?.heart_rate || 0}
                                      </div>
                                      <div
                                        className="acitivboxuptexbp"
                                        style={{ color: "#E91717" }}
                                      >
                                        BPM
                                      </div>
                                    </div>
                                    <div
                                      className="acitivbox1"
                                      style={{ background: "#f9bcbb" }}
                                    >
                                      <div className="acitivboxicon -md:mt-20 -mt-10">
                                        <img
                                          loading="lazy"
                                          src="../images/deshboard/heart-beat.png"
                                          alt="heartbeat"
                                          style={{ width: "108px" }}
                                        />
                                      </div>
                                      <div
                                        className="acitivboxuptex acitivlerate"
                                        style={{
                                          color: "#E91717",
                                          marginTop: "-15%",
                                        }}
                                      >
                                        HR
                                      </div>
                                    </div>
                                  </div>
                                </Link>

                                <Link
                                  to={"/track/health/details"}
                                  state={{ option: "weight", data: null }}
                                >
                                  <div className="acitivbox w-full">
                                    <div className="acitivlerate mb-0">
                                      <div className="acitivboxtex">
                                        {" "}
                                        {reportData?.weight?.currentWeight
                                          ?.weight || 0}
                                      </div>
                                      <div className="acitivboxuptexbp">
                                        {reportData?.weight?.currentWeight
                                          ?.weightUnit || "Kg"}
                                      </div>
                                    </div>
                                    <div className="acitivbox1">
                                      <div className="acitivboxicon -md:mt-20 -mt-10">
                                        <img
                                          loading="lazy"
                                          src="../images/deshboard/weight2.png"
                                          alt="weight"
                                          style={{ width: "108px" }}
                                        />
                                      </div>
                                      <div
                                        className="acitivboxuptex acitivlerate"
                                        style={{ marginTop: "-15%" }}
                                      >
                                        Weight
                                      </div>
                                    </div>
                                  </div>
                                </Link>

                                <Link
                                  to={"/track/health/details"}
                                  state={{ option: "walk", data: null }}
                                >
                                  <div
                                    className="acitivbox w-full"
                                    style={{ background: "#e8eff7" }}
                                  >
                                    <div className="acitivlerate mb-0">
                                      <div
                                        className="acitivboxtex"
                                        style={{ color: "#197bd2" }}
                                      >
                                        {week_row?.totalSteps || 0}
                                      </div>
                                      <div
                                        className="acitivboxuptexbp"
                                        style={{ color: "#197bd2" }}
                                      >
                                        Steps
                                      </div>
                                    </div>

                                    <div
                                      className="acitivbox1"
                                      style={{ background: "#bfd8f0" }}
                                    >
                                      <div className="acitivboxicon -md:mt-20 -mt-10">
                                        <img
                                          loading="lazy"
                                          src="../images/deshboard/arrow1.png"
                                          alt="arrow"
                                          style={{ width: "108px" }}
                                        />
                                      </div>
                                      <div
                                        className="acitivboxuptex acitivlerate"
                                        style={{
                                          color: "#197bd2",
                                          marginTop: "-15%",
                                        }}
                                      >
                                        Walk
                                      </div>
                                    </div>
                                  </div>
                                </Link>
                              </div>
                            );
                          }
                        }
                      )}
                  </div>
                </div>
                {/* Line graph right section */}
                {!weekhasValidData && (
                  // Run else part when no valid day_row is found
                  <NotFound />
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </MainBg>
  );
};

export default React.memo(HealthTrack);
